import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function Protected({ role, children }) {
  const { user, logout } = useAuth();
  if (user === null) {
    return <div className="grid min-h-screen place-items-center"><Loader2 className="h-6 w-6 animate-spin text-sky-400" /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.status && user.status !== "active") {
    return (
      <main className="mx-auto flex min-h-screen max-w-2xl flex-col justify-center px-5 pt-24" data-testid="pending-approval">
        <p className="eyebrow">{user.status === "rejected" ? "Access declined" : "Awaiting approval"}</p>
        <h1 className="mt-5 font-display text-4xl font-semibold tracking-tight sm:text-5xl">
          {user.status === "rejected" ? "Your access request was not approved." : `Thanks, ${user.name}. You're on the list.`}
        </h1>
        <p className="mt-5 text-slate-300">
          {user.status === "rejected" ? "Contact the MidHq team if you think this is a mistake." : `MidHq will review ${user.email} and switch on your Corridor Portal access.`}
        </p>
        <button onClick={logout} className="btn-ghost mt-10 self-start" data-testid="pending-logout">Sign out</button>
      </main>
    );
  }
  if (role && user.role !== role) return <Navigate to="/portal" replace />;
  return children;
}

export const STATUS_STYLE = {
  received: "border-slate-400/40 text-slate-200",
  new: "border-slate-400/40 text-slate-200",
  reviewing: "border-sky-400/50 text-sky-300",
  underwriting: "border-sky-400/50 text-sky-300",
  pending_docs: "border-amber-400/50 text-amber-300",
  approved: "border-emerald-400/50 text-emerald-300",
  boarded: "border-emerald-400/50 text-emerald-300",
  declined: "border-rose-400/50 text-rose-300",
  replied: "border-emerald-400/50 text-emerald-300",
  archived: "border-white/20 text-slate-400",
  rejected: "border-rose-400/50 text-rose-300",
  active: "border-emerald-400/50 text-emerald-300",
  paid: "border-emerald-400/50 text-emerald-300",
  pending: "border-amber-400/50 text-amber-300",
};

export const Badge = ({ s, testid }) => (
  <span data-testid={testid} className={`inline-block rounded-full border px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-wider ${STATUS_STYLE[s] || "border-white/20 text-slate-300"}`}>
    {String(s || "").replace("_", " ")}
  </span>
);

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "");
